import { cn } from 'utils';

/**
 * NOTE: Styles are collected here to help better coordinate the responsive effects of related components.
 */

export const camerasPanelStyles = {
  camerasList: cn(
    'odin-flex',
    'odin-flex-row',
    'odin-gap-2',
    'odin-order-2',
    'odin-overflow-x-auto',
    'odin-overflow-y-hidden',
    'odin-w-full',
    'lg:odin-flex-col',
    'lg:odin-overflow-x-hidden',
    'lg:odin-overflow-y-auto',
    'lg:odin-order-1',
    'lg:odin-w-[240px]',
  ),
  camerasListItem: cn(
    'odin-h-auto',
    'odin-min-h-[100px]',
    'odin-min-w-[160px]',
    'lg:odin-min-h-[132px]',
    'lg:odin-w-full',
  ),
  mainCamera: cn(
    'odin-bg-odin-black',
    'odin-flex',
    'odin-flex-1',
    'odin-flex-col',
    'odin-items-center',
    'odin-justify-center',
    'odin-order-1',
    'odin-overflow-hidden',
    'odin-rounded-md',
    'lg:odin-order-2',
  ),
  root: cn(
    'odin-flex',
    'odin-flex-col',
    'odin-gap-4',
    'odin-order-1',
    'odin-overflow-hidden',
    'lg:odin-flex-row',
    'xl:odin-col-span-1',
  ),
};

export const pulseHeaderStyles = {
  content: cn(
    'odin-flex',
    'odin-w-full',
    'odin-gap-4',
    'odin-items-center',
    'md:odin-w-auto',
    'md:odin-flex-1',
    'lg:odin-flex-initial',
  ),
  root: cn(
    'odin-flex',
    'odin-flex-1',
    'odin-gap-1',
    'odin-items-center',
    'odin-flex-wrap',
    'lg:odin-gap-4',
  ),
  title: cn(
    'odin-font-bold',
    'odin-text-lg',
    'odin-w-full',
    'lg:odin-flex-1',
    'lg:odin-w-auto',
  ),
};

export const pulseMainStyles = {
  grid: cn(
    'odin-gap-4',
    'odin-flex',
    'odin-flex-col',
    'pulseXl:odin-grid',
    'pulseXl:odin-grid-cols-[1fr_320px]',
    'pulseXl:odin-grid-rows-[40vh_auto]',
    'pulse2Xl:odin-grid-cols-[1fr_360px]',
    'pulse2Xl:odin-grid-rows-[50vh_auto]',
    'pulse3Xl:odin-grid-cols-[1fr_420px]',
    'pulse3Xl:odin-grid-rows-[60vh_auto]',
    'pulse4Xl:odin-grid-rows-[70vh_auto]',
  ),
  root: 'odin-flex odin-flex-col odin-gap-4',
};

export const snapshotPanelStyles = {
  accessEvents: cn(
    'odin-flex',
    'odin-flex-col',
    'odin-gap-1',
    'xl:odin-flex-1',
    'xl:odin-order-1',
    'pulseXl:odin-flex-initial',
    'pulseXl:odin-order-2',
  ),
  activity: cn(
    'odin-flex',
    'odin-flex-col',
    'odin-gap-2',
    'xl:odin-flex-1',
    'xl:odin-order-2',
    'pulseXl:odin-flex-initial',
    'pulseXl:odin-order-1',
  ),
  root: cn(
    'odin-flex',
    'odin-flex-1',
    'odin-flex-col',
    'odin-gap-4',
    'odin-order-3',
    'odin-overflow-x-hidden',
    'odin-overflow-y-auto',
    'xl:odin-flex-row',
    'pulseXl:odin-col-span-1',
    'pulseXl:odin-order-2',
    'pulseXl:odin-flex-col',
  ),
};

export const timelinePanelStyles = {
  root: cn('odin-order-2', 'pulseXl:odin-col-span-2', 'pulseXl:odin-order-3'),
};
